import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './email-forwarding-info.component.html',
  styleUrl: './email-forwarding-info.component.scss',
})
export class EmailForwardingInfoComponent {}
